export const calculateWeeksLoved = (dob) => {
    if (!dob) return 0;
    const birthDate = new Date(dob);
    const today = new Date();
    
    // Return 0 if date is in the future
    if (birthDate > today) return 0;
    
    const diffTime = Math.abs(today - birthDate);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24 * 7));
}; 